/**
 * This is a global vue mixing for access control.
 * Acts a wrapper for the Access class so the methods can be used
 * in v-if else directives.
 */

export default Vue.mixin({
	methods: {
		/**
		 * Determine if user has permission to do something.
		 *
		 * @param {string} perm
		 */
		allow(perm) {
			return Access.allow(perm);
		},

		/**
		 * Determine if user has multiple permissions.
		 *
		 * @param {array} perms
		 * @param {bool} needs_all
		 */
		allowMultiple(perms, needs_all = false) {
			return Access.allowMultiple(perms, needs_all);
		},

		/**
		 * Add perms to check.
		 *
		 * @param {array} perms
		 */
		addPerms(perms) {
			Access.addPerms(perms);
		},

		/**
		 * Determine if a user belongs to a certain company.
		 * 
		 * @param {integer} company_id
		 * @param {bool} debug
		 */
		company(company_id, debug = true) {
			return Access.company(company_id, debug);
		},

		/**
		 * Determine if the user is a developer.
		 */
		developer() {
			return Access.isDeveloper();
		},

		/**
		 * Determine if the user is a super admin.
		 */
		superAdmin() {
			return Access.isSuperAdmin();
		}
	}
})